__turbopack_context__.v({
  "expandableCopy": "idQYya_expandableCopy",
  "wrapper": "idQYya_wrapper",
});
